import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import DashboardLayout from './components/DashboardLayout';
import DashboardPage from './pages/DashboardPage';
import BusinessAwarenessPage from './pages/BusinessAwarenessPage';
import AuthCallback from './pages/AuthCallback';
import AccessDeniedPage from './pages/AccessDeniedPage';
import StrategicObjectivesPage from './pages/StrategicObjectivesPage';
import { Box, CircularProgress } from '@mui/material';

/**
 * Componente que gerencia as rotas protegidas.
 * A lógica de proteção agora é mais simples, pois o AuthContext já tratou do redirecionamento.
 */
const AppRoutes = () => {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    // Se após o loading não houver usuário, significa que o redirecionamento falhou ou
    // o usuário está em uma rota que não deveria estar. Mostramos acesso negado como um fallback.
    if (!user) {
        return <AccessDeniedPage />;
    }

    // Se o usuário existe, renderiza o layout com as rotas protegidas.
    return (
        <DashboardLayout>
            <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/business-awareness" element={<BusinessAwarenessPage />} />
                {/* Assumindo que esta rota é protegida, ela deve estar aqui dentro */}
                <Route path="/strategic-objectives" element={<StrategicObjectivesPage />} />
            </Routes>
        </DashboardLayout>
    );
};

/**
 * Componente principal
 */
const App = () => {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    {/* Rota de Callback é pública e não usa o AppRoutes */}
                    <Route path="/auth/callback" element={<AuthCallback />} />
                    
                    {/* A rota de acesso negado também é pública */}
                    <Route path="/access-denied" element={<AccessDeniedPage />} />
                    
                    {/* Todas as outras rotas são gerenciadas pelo AppRoutes, que contém a lógica de proteção */}
                    <Route path="/*" element={<AppRoutes />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
};

export default App;